const padLeft = value => {
    const str = value.toString();

    return str.length === 1 ? '0' + str : str;
};

const setInnerText = (el, text) => (el.innerText = text);

const forEachElement = (elements, fb) => Array.prototype.forEach.call(elements, fb);

const lastInIndex = arr => arr[arr.length - 1];

// controlls the speed of the scroll animation
const scrollStep = 50;
const sliderBlocks = document.querySelectorAll('.wp-block-snla-slider');

forEachElement(sliderBlocks, sliderBlock => {
    // DOM elements
    const slider = sliderBlock.querySelector('.slides');

    const sliderWrapper = sliderBlock.querySelector('.slides-wrapper');

    const slides = sliderBlock.querySelectorAll(
        '.wp-block-snla-column.slides .wp-block-snla-link-page'
    );

    const sliderCounters = sliderBlock.querySelectorAll(
        '.wp-block-snla-slider-nav-buttons__content'
    );

    const forwardButtons = sliderBlock.querySelectorAll(
        '.wp-block-snla-slider-nav-buttons__button-forward'
    );

    const backButtons = sliderBlock.querySelectorAll(
        '.wp-block-snla-slider-nav-buttons__button-back'
    );

    // variables
    const totalSlides = slides.length;
    const lastSlideIndex = totalSlides - 1;
    // offsetLeft is based on browser window
    let sliderOffsetLeft = slider.offsetLeft;
    let slidesOffsets = Array.prototype.map.call(slides, s => s.offsetLeft - sliderOffsetLeft);

    let currentSlideIndex = 0;
    let currentScrollLeft = 0;
    let isInScrollingFx = false;

    const adjustOffsets = () => {
        sliderOffsetLeft = slider.offsetLeft;
        slidesOffsets = Array.prototype.map.call(slides, s => s.offsetLeft - sliderOffsetLeft);
    };

    window.addEventListener('resize', adjustOffsets);

    const updateSliderButtons = () => {
        const currentIndex = padLeft(currentSlideIndex + 1);

        forEachElement(sliderCounters, e =>
            setInnerText(e, `${currentIndex}/${padLeft(totalSlides)}`)
        );

        if (currentSlideIndex === 0) {
            forEachElement(backButtons, bb => bb.setAttribute('disabled', true));
        } else {
            forEachElement(backButtons, bb => bb.removeAttribute('disabled'));
        }
    };

    updateSliderButtons();

    const scrollToPoint = endPosition => {
        isInScrollingFx = true;

        let position = slider.scrollLeft;

        // scroll animation
        // wanted to use scroll-behavior but that dont work in Safari
        // source: https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
        const loopAnimateScroll = () => {
            const movedRight = currentScrollLeft < endPosition;
            const step = movedRight ? scrollStep : scrollStep * -1;

            const newPosition = position + step;

            // dont step over endPosition with newPosition
            if (movedRight) {
                position = newPosition > endPosition ? endPosition : newPosition;
            } else {
                position = newPosition > endPosition ? newPosition : endPosition;
            }

            // actual scroll
            slider.scrollLeft = Math.floor(position);

            if (position !== endPosition) {
                // scroll again when browser is ready
                window.requestAnimationFrame(loopAnimateScroll);
            } else {
                // done with scrolling
                currentScrollLeft = slider.scrollLeft;

                currentSlideIndex = slidesOffsets.indexOf(endPosition);

                updateSliderButtons();

                isInScrollingFx = false;
            }
        };

        // start scroll animation
        window.requestAnimationFrame(loopAnimateScroll);
    };

    const buttonOnClick = stepBackwards => {
        return () => {
            if (stepBackwards && lastSlideIndex >= currentSlideIndex) {
                currentSlideIndex -= 1;
            } else if (!stepBackwards && lastSlideIndex > currentSlideIndex) {
                currentSlideIndex += 1;
            } else {
                currentSlideIndex = 0;
            }

            // scroll til element
            const newScrollPosition = slidesOffsets[currentSlideIndex];

            scrollToPoint(newScrollPosition);
        };
    };

    forEachElement(forwardButtons, fb => fb.addEventListener('click', buttonOnClick(false)));

    forEachElement(backButtons, bb => bb.addEventListener('click', buttonOnClick(true)));

    // Setup isScrolling variable
    let scrollEventTimer;

    // Listen for scroll events
    slider.addEventListener(
        'scroll',
        () => {
            // Clear our timeout throughout the scroll
            window.clearTimeout(scrollEventTimer);

            // don't do anything if view is scrolling
            if (isInScrollingFx) {
                return;
            }

            // Set a timeout to run after scrolling ends
            scrollEventTimer = setTimeout(() => {
                // don't do anything if view is scrolling
                if (isInScrollingFx) {
                    return;
                }

                const newScrollLeft = slider.scrollLeft;

                if (newScrollLeft === currentScrollLeft) {
                    return;
                }

                const movedRight = currentScrollLeft < newScrollLeft;

                if (movedRight) {
                    // find next offset in offsets.
                    // if no match use last offset
                    const newScrollPosition =
                        slidesOffsets.find(o => o > newScrollLeft) || lastInIndex(slidesOffsets);

                    scrollToPoint(newScrollPosition);
                } else {
                    // Use largest offsets from filtered.
                    // if no match use 0
                    const newScrollPosition =
                        slidesOffsets.filter(o => o < newScrollLeft).pop() || 0;

                    scrollToPoint(newScrollPosition);
                }
            }, 100);
        },
        false
    );

    // handling of keyboard navigation with the focus event
    forEachElement(slides, el => {
        el.addEventListener('focus', () => {
            // venter 200 ms med å kjøre animasjon i tilfelle focus skjer ved klikk
            // se issue for mer info: https://snla-git.teknograd.no/akuttdagen/wp-akuttdagen-theme/-/issues/144
            setTimeout(() => {
                const index = Array.prototype.indexOf.call(sliderWrapper.children, el);

                if (index !== -1) {
                    currentSlideIndex = index;

                    // scroll til element
                    const newScrollPosition = slidesOffsets[currentSlideIndex];

                    scrollToPoint(newScrollPosition);
                }
            }, 200);
        });
    });
});
